import { removeDuplicatedEvents } from "../helpers/events";

export const eventsReducer = (state, action) => {
  switch (action.type) {
    case "SET_LOADING":
      return {
        ...state,
        isLoading: action.payload,
      };
    case "SET_SELECTED_DATES":
      return {
        ...state,
        selectedDates: action.payload.dates,
        visibleEventsCount: action.payload.visibleEventsCount,
      };
    case "CLEAR_DATES":
      return {
        ...state,
        selectedDates: [],
        eventsInRange: [],
        visibleEventsCount: action.payload.visibleEventsCount,
        nextPageId: 1,
        isLastPage: false,
      };
    case "CLEAR_SELECTED_CATEGORIES":
      return {
        ...state,
        selectedMainCategory: null,
        selectedSubCategories: [],
      };
    case "SET_SELECTED_MAIN_CATEGORY":
      return {
        ...state,
        selectedMainCategory: action.payload,
      };
    case "SET_SELECTED_SUB_CATEGORIES":
      return {
        ...state,
        selectedSubCategories: action.payload,
      };

    case "SET_VISIBLE_EVENTS_COUNT":
      return {
        ...state,
        visibleEventsCount: action.payload,
      };
    case "LOAD_EVENTS_SUCCESS":
      return {
        ...state,
        eventsInRange: action.payload.events.filter(removeDuplicatedEvents),
        nextPageId: action.payload.nextPageId ?? 1,
        isLastPage: action.payload.isLastPage,
        visibleEventsCount: action.payload.visibleEventsCount,
        isLoading: false,
      };
    case "LOAD_ONGOING_EVENTS_SUCCESS":
      return {
        ...state,
        ongoingEvents: action.payload.events,
      };
    default:
      return state;
  }
};
